import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccCheckoutAdapter } from '@spartacus/checkout/base/occ';
import {
  Address, ADDRESS_SERIALIZER,
  InterceptorUtil,
  OCC_USER_ID_ANONYMOUS,
  USE_CLIENT_TOKEN
} from '@spartacus/core';
import { Order } from '@spartacus/order/root';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CustomCheckoutAdapter } from '../../../src/checkout/connectors/custom-checkout.adapter';
import { CustomPayPalPayment, CustomRedsysPayment } from '../../../src/checkout/models/custom-checkout.model';
import { CustomOcc } from '../../occ-models/custom-occ.models';

@Injectable()
export class CustomOccCheckoutAdapter extends OccCheckoutAdapter implements CustomCheckoutAdapter {
  public loadRedsysPayment(
    userId: string,
    cartId: string,
    saveCard: boolean,
  ): Observable<CustomRedsysPayment> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    if (userId === OCC_USER_ID_ANONYMOUS) {
      headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);
    }
    headers = InterceptorUtil.createHeader('saveCard', true, headers);
    let url = this.occEndpoints.buildUrl('redsysPayment', { urlParams: { userId, cartId, saveCard } });
    if (saveCard) {
      url += '&saveCard=' + saveCard;
    }
    return this.http.get<CustomOcc.RedsysPayment>(url, { headers });
  }

  public loadSequraPayment(
    userId: string,
    cartId: string,
    paymentId: string,
  ): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    if (userId === OCC_USER_ID_ANONYMOUS) {
      headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);
    }
    const url = this.occEndpoints.buildUrl('sequraPayment', { urlParams: { userId, cartId, paymentMethod: paymentId } });
    return this.http.get<any>(url, { headers });
  }

  public loadPaypalPayment(
    userId: string,
    cartId: string,
    paymentId: string,
  ): Observable<CustomPayPalPayment> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    if (userId === OCC_USER_ID_ANONYMOUS) {
      headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);
    }
    const url = this.occEndpoints.buildUrl('paypalPayment', { urlParams: { userId, cartId, paymentId } });
    return this.http.get<CustomOcc.PayPalPayment>(url, { headers });
  }

  public createPaypalOrder(
    userId: string,
    cartId: string,
    paymentId: string,
    token: string,
    PayerID: string
  ): Observable<Order> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    if (userId === OCC_USER_ID_ANONYMOUS) {
      headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);
    }
    const url = this.occEndpoints.buildUrl('paypalCreateOrder', { urlParams: { userId, cartId, paymentId, token, PayerID } });
    return this.http.get<Order>(url, { headers });
  }


  public simulateOrder(
    userId: string,
    cartId: string
  ): Observable<any> {
    const url = this.occEndpoints.buildUrl('simulate', { urlParams: { userId, cartId } });
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    if (userId === OCC_USER_ID_ANONYMOUS) {
      headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);
    }
    return this.http.put<any>(url, { headers });
  }

  public validateCart(
    userId: string,
    cartId: string
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const url = this.occEndpoints.buildUrl('validateRealtimeStock', { urlParams: { userId, cartId } });
    return this.http.post(url, { headers });
  }

  public unavailableProducts(
    userId: string,
    cartId: string
  ): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    if (userId === OCC_USER_ID_ANONYMOUS) {
      headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);
    }
    const url = this.occEndpoints.buildUrl('unavailableProducts', { urlParams: { userId, cartId } });
    return this.http.post(url, { headers });
  }

  update(userId: string, addressId: string, address: Address): Observable<{}> {
    const url = this.occEndpoints.buildUrl('addressDetail', {
      urlParams: {
        userId,
        addressId,
      }
    });
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    address = this.converter.convert(address, ADDRESS_SERIALIZER);

    return this.http
      .patch(url, address, { headers })
      .pipe(catchError((error: any) => throwError(error)));
  }
}
